import { useState, useEffect } from "react";
import { Box, Flex, FormControl, Textarea, FormLabel } from "@chakra-ui/react";
import WarningTextMessage from "../../../global/components/helper-components/components/WarningTextMessage";

export default function LaunchdeckFormTextAreaInput({
  // Inherited values
  name, charLimit, value, label, placeholder,
  // Functions
  onChange, onBlur, onPressEnter,
  // Error Handling
  errorMessage, errorLogic,
  // UIUX Options
  isRequired, isInvalid, cursor, autoFocus, type, isDisabled, showIsOptional,
  // Styling options
  p, bg, fontSize, labelFontSize, fontWeight, noBorder, minH
}) {

  const [remainingChar, setRemainingChar] = useState(charLimit ? charLimit : "")
  useEffect(() => {
    if (charLimit && value?.length >= 0) {
      const currentCharacters = value?.length || 0;
      setRemainingChar(charLimit - currentCharacters)
    }
  }, [charLimit, value])

  return (
    <FormControl variant={"floating"} w='100%' onKeyDown={onPressEnter && onPressEnter} isRequired={isRequired} isInvalid={isInvalid || errorLogic} >
      <Textarea
        name={name && name}
        autoFocus={autoFocus && autoFocus}
        onBlur={onBlur && onBlur}
        value={value && value}
        placeholder={placeholder || ""}
        onChange={onChange && onChange}
        // Styling
        minH={minH || "6em"}
        fontSize={fontSize ? fontSize : '0.875em'}
        p={p ? p : '1.2em 1em'}
        mb='0.2em'
        w='100%'
        fontWeight={fontWeight ? fontWeight : '400'}
        color='brandDark.500'
        my='0.5em'
        borderRadius='0.25em'
        bg={isDisabled ? "gray.100" : bg || "white"}
        border={noBorder ? 'none' : '1px solid'}
        borderColor={"gray.300"}
        cursor={cursor && cursor}
        // Input UX 
        onInput={(e) => (e.target.style.height = "auto", e.target.style.height = `${e.target.scrollHeight}px`)}
        _invalid={{
          boxShadow: "none",
          borderColor: "brandPink.500",
        }}
        _focus={{
          boxShadow: "none !important",
          borderColor: "brand.500",
          outline: "none",
        }}
        // UI-UX
        className='fade-in'
        type={type}
        isDisabled={isDisabled || false}
        transition="border 0.3s ease-in-out"
      />

      {/* It is important that the Label comes after the Control due to css selectors */}
      {placeholder ?
        <Box
          color='gray.500'
          top='-5px'
          left='0.5em'
          position='absolute'
          fontWeight='600'
          bg='white'
          zIndex='2'
          fontSize={'0.7em'}
          px='1em'>{label}
          {isRequired && <span style={{ color: '#FF2847' }}> *</span>}
        </Box>
        :
        <FormLabel fontSize={labelFontSize || '0.875em'} position="relative" top='3px' bg={'none'} color='gray.500'>{label}{showIsOptional && <Box as='span' fontSize='0.7em' color='gray.500' ml='1em'>(OPTIONAL)</Box>}</FormLabel>
      }

      <Box textAlign='left'>
        {errorLogic ? <WarningTextMessage errorLogic={errorLogic} message={errorMessage} />
          : charLimit ? <Flex justify='flex-end' w='100%' color='gray.500' fontSize='0.65em' pt='0.2em'>
            {remainingChar} characters remaining
          </Flex> : null
        }
      </Box>

    </FormControl>
  );

}